import { Injectable } from '@angular/core';
import {
  CanActivate, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthService } from './../models/auth.service';
import { UserRoles, ApplicationRouteURL } from '../config';

@Injectable()
export class OrgAdminAuthGuard implements CanActivate {
  constructor(private authService: AuthService
    , private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {

    if (this.authService.isAuthorized(UserRoles.ORGANIZATIONADMIN)) {
      let urlBatchUpload = this.authService.GetURL(ApplicationRouteURL.URL_BATCHUPLOADPERSON);
      let urlOrganizationUpdate = this.authService.GetURL(ApplicationRouteURL.URL_ORGANIZATION_UPDATE);

      if (state.url == urlBatchUpload) {
        return this.IsAuthorizeFor(this.authService.MODULE_NAME.PersonBatchUpload);
      } else if (state.url == urlOrganizationUpdate) {
        return this.IsAuthorizeFor(this.authService.MODULE_NAME.CreateOrganization);
      } else {
        return true;
      }
    } else {
      // Navigate to the login page
      this.router.navigate(['/Unauthorized']);
      return false;
    }

    // Store the attempted URL for redirecting 
    //this.authService.redirectUrl = state.url;
  }

  IsAuthorizeFor(moduleName: string) {
    return this.authService.IsAuthorizeFor(moduleName)
      .map(res => {
        if (!res.data) {
          this.router.navigate(['/NotFound']);
        }
        return res.data;
      });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/guard/auth-guard-orgadmin.service.ts